import { RootState } from 'app/rootReducer';

import { DisplayNotification } from './interface';

export const getAllNotifications = (state: RootState): DisplayNotification[] =>
  state.notification;
